// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contain[data-v-516b571d] {\n  padding: 30px;\n  background: #f2f5f7;\n}\n.contain .checkBox[data-v-516b571d] {\n    margin-bottom: 15px;\n}\n.dialog .addGroupBtn[data-v-516b571d] {\n  position: absolute;\n  right: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
